import React from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import { colors, resolveColor } from "utils/styles";
import { Icon } from "components/Icons";

import Title from "components/Reusables/Title";
import Content from "components/Reusables/Content";
export default function Quote(props) {
	const asItem = props.asItem;
	const fields = props.data?.fields;
	const classList = fields?.class;
	const alignAttribution = fields?.alignAttribution || "center";
	const wrapperBgColor = fields?.wrapperBackgroundColor;
	const topPadding = fields?.topPadding !== undefined ? fields?.topPadding : 4;
	const bottomPadding = fields?.bottomPadding !== undefined ? fields?.bottomPadding : 4;
	// const topMargin = fields?.topMargin !== undefined ? fields?.topMargin : 5;
	// const bottomMargin = fields?.bottomMargin !== undefined ? fields?.bottomMargin : 5;
	const isContainer = fields?.isContainer !== undefined ? fields?.isContainer : false;

	const quoteMarkerColor = resolveColor(fields?.quoteMarkerColor);
	const lowerBackgroundColor = fields.lowerBackgroundColor ? resolveColor(fields.lowerBackgroundColor) : false;
	const lowerBackgroundHeight = fields.lowerBackgroundHeight ? fields.lowerBackgroundHeight : "50";

	const titleWidth = fields?.quote?.fields?.maxWidth ? fields?.quote?.fields?.maxWidth : 800;
	return (
		<div className={`pt-lg-${topPadding} pb-lg-${bottomPadding}  outerWrapper QuoteSection`}>
			{lowerBackgroundColor && <div className="lowerBackground"></div>}

			<Container
				fluid
				className={`pt-${topPadding} pb-${bottomPadding}   ${
					isContainer ? `container-${isContainer}` : ""
				} g-0`}
			>
				{/* <Row className="g-0 ">
					<Col className=""> */}
				<div className={` quote-container py-4  ${classList ? classList : ""} `}>
					<Row className="justify-content-center p-3 g-0">
						{asItem && (
							<Col className="text-center" md="auto">
								<Icon color={quoteMarkerColor} icon="quote" />
							</Col>
						)}
						<Col className=" text-center">
							{!asItem && <Icon color={quoteMarkerColor} icon="quote" />}

							{/* Title */}
							<Row className="g-0">
								<Col className="px-0 px-lg-0  d-flex ">
									<div className={`quote-max-width}`}>
										{fields?.quote && <Title title={fields?.quote} />}
									</div>
								</Col>
							</Row>

							{/* content */}
							<Row className={`justify-content-${alignAttribution}  g-0`}>
								<Col className="px-0">
									{fields?.attribution && <Content content={fields?.attribution} />}
								</Col>
							</Row>
						</Col>
					</Row>
				</div>
				{/* </Col>
				</Row> */}
			</Container>
			<style jsx="true">{`
				.quote-max-width {
					max-width: ${titleWidth};
				}
				.outerWrapper {
					background: ${resolveColor(wrapperBgColor) || "white"};
					position: relative;
					z-index: 1;
				}

				.lowerBackground {
					position: absolute;
					left: 0;
					right: 0;
					bottom: 0;
					top: ${lowerBackgroundHeight}%;
					background: ${lowerBackgroundColor};
					z-index: -1;
				}

				.quoteMark {
					color: ${colors.red};
					font-weight: bold;
					font-size: 200px;
					font-family: "Fuzzy Bubbles";
				}
				.quote-container {
					background: ${props.bgColor || colors[props.data?.fields?.backgroundColor?.fields?.color]};
					display: flex;
					align-items: center;
					justify-content: center;
				}

				.content {
					font-size: 17px;
					line-height: 28px;
					font-family: "Open Sans";
					color: ${colors.yellow};
				}
			`}</style>
		</div>
	);
}
